import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=6339136f&scoped=true"
import script from "./verification.vue?vue&type=script&lang=js"
export * from "./verification.vue?vue&type=script&lang=js"
import style0 from "./verification.vue?vue&type=style&index=0&id=6339136f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6339136f",
  null
  
)

export default component.exports